module.exports = __webpack_public_path__ + "static/img/avatar_default_preview2.dc726974.png";